module.exports = __webpack_public_path__ + "img/chain_industry-solution1.bc3200f8.png";